"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineNumberingProperties = exports.LineNumberDefaults = void 0;
var enums_1 = require("./enums");
var LineNumberDefaults = (function () {
    function LineNumberDefaults() {
    }
    LineNumberDefaults.countBy = 0;
    LineNumberDefaults.start = 1;
    LineNumberDefaults.distance = 360;
    LineNumberDefaults.restart = enums_1.LineNumberingRestartType.NewPage;
    return LineNumberDefaults;
}());
exports.LineNumberDefaults = LineNumberDefaults;
var LineNumberingProperties = (function () {
    function LineNumberingProperties(countBy, start, distance, restart) {
        if (countBy === void 0) { countBy = LineNumberDefaults.countBy; }
        if (start === void 0) { start = LineNumberDefaults.start; }
        if (distance === void 0) { distance = LineNumberDefaults.distance; }
        if (restart === void 0) { restart = LineNumberDefaults.restart; }
        this.countBy = countBy;
        this.start = start;
        this.distance = distance;
        this.restart = restart;
    }
    Object.defineProperty(LineNumberingProperties.prototype, "isDefined", {
        get: function () {
            return this.countBy !== LineNumberDefaults.countBy;
        },
        enumerable: false,
        configurable: true
    });
    LineNumberingProperties.prototype.copyFrom = function (obj) {
        this.countBy = obj.countBy;
        this.distance = obj.distance;
        this.restart = obj.restart;
        this.start = obj.start;
    };
    LineNumberingProperties.prototype.clone = function () {
        var result = new LineNumberingProperties();
        result.copyFrom(this);
        return result;
    };
    LineNumberingProperties.prototype.equals = function (obj) {
        return obj &&
            this.countBy === obj.countBy &&
            this.distance === obj.distance &&
            this.restart === obj.restart &&
            this.start === obj.start;
    };
    return LineNumberingProperties;
}());
exports.LineNumberingProperties = LineNumberingProperties;
